import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Grid,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core/";
import countryCodes from "country-codes-list";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import Aux from "../../hoc/Auxilliary";
import FormBuilder from "../FormBuilder";
import FormSourceData from "./formData";
import FormStyle from "./prospective.module.css";
import UploadForm from "./formUpload";
import {
  getApplicationData,
  updateApplicationEditData,
  postApplicationData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearApplicationData,
  saveFileUploadData,
  getApplicantFee,
  clearApplicantStatus,
  getInquiryData,
  getApplicationsByAppicantId,
  getApplicantCheckList,
} from "../../reduxSlices/applicationSlice";
import { isObjectEmpty, dateFormatter } from "../../utils/general";
import Backdrop from "../Backdrop";
import FormHeader from "../FormHeader";
import fields from "./requiredFields";
import MessageIndicator from "../SnackBar";
import { clearLoginData, isLoggedInUpdate } from "../../reduxSlices/loginSlice";
import localizedStrings from "../../utils/localize";
import { getApplicantStatus } from "../../reduxSlices/applicationSlice";

import {
  getOptionList,
  getfileTypesList,
  getpreferredContactList,
  getpreferredGenderCode,
} from "../../reduxSlices/applicationSlice";
import CheckList from "./CheckList";

const useStyle = makeStyles((theme) => ({
  container: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
  formDesignMain: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  formHead: {
    padding: "0.9rem 0.7rem",
    background: "#005598",
    color: "#fff",
    width: "95.7%",
  },
  formDesign: {
    width: "95%",
    margin: "0 auto",
  },
  bottomControls: {
    display: "flex",
    justifyContent: "space-between",
    margin: "0.6rem auto",
    width: "100%",
  },
  btnNext: {
    marginRight: "4.5rem",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0",
    },
  },
  tableStyle: {
    width: "90%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    container: {
      height: "100%", // So that grids 1 & 4 go all the way down
      minHeight: 150, // Give minimum height to a div
      border: "1px solid black",
      fontSize: 30,
      textAlign: "center",
    },
    containerTall: {
      minHeight: 250, // This div has higher minimum height
    },
  },
}));

var filtterFormData = {};
var fileUploadForm = [];

var programs = [];
const ProspectivePage = (props) => {
  const classes = useStyle(props);
  const [personalInformation, setPersonalInformation] = useState(
    FormSourceData.personalInformation,
  );
  const [contactInformation, setContactInformation] = useState(
    FormSourceData.contactInformation,
  );
  const [emergenencyContact, setEmergenencyContact] = useState(
    FormSourceData.emergenencyContact,
  );
  const [applicationItem, setApplicationItem] = useState(
    FormSourceData.applicationItem,
  );
  const [completionDate, setCompletionDate] = useState(
    FormSourceData.completionDate,
  );
  const [notes, setNotes] = useState(FormSourceData.notes);
  const [miscellanous, setMiscellanous] = useState(FormSourceData.miscellanous);
  for (let item in personalInformation) {
    filtterFormData[item] = personalInformation[item].value;
  }
  for (let item in contactInformation) {
    filtterFormData[item] = contactInformation[item].value;
  }
  // for (let item in education.Undergraduate) {
  //   filtterFormData[item] = education.Undergraduate[item].value;
  // }
  // for (let item in education.graduate) {
  //   filtterFormData[item] = education.graduate[item].value;
  // }
  for (let item in miscellanous) {
    filtterFormData[item] = miscellanous[item].value;
  }

  for (let item in emergenencyContact) {
    filtterFormData[item] = emergenencyContact[item].value;
  }
  for (let item in applicationItem) {
    filtterFormData[item] = applicationItem[item].value;
  }
  for (let item in completionDate) {
    filtterFormData[item] = completionDate[item].value;
  }

  for (let item in notes) {
    filtterFormData[item] = notes[item].value;
  }

  const [formNavData, setFormNavData] = useState([
    {
      id: FormSourceData.personalInformation,
      value: "Personal information",
    },
    {
      id: FormSourceData.contactInformation,
      value: "Contact information",
    },
    {
      id: FormSourceData.emergenencyContact,
      value: "Emergency Contact",
    },
    {
      id: FormSourceData.miscellanous,
      value: "Miscellaneous",
    },
    {
      id: FormSourceData.applicationItem,
      value: "Application Item",
    },
    {
      id: FormSourceData.completionDate,
      value: "Completion Date",
    },
    {
      id: FormSourceData.notes,
      value: "Notes",
    },
  ]);
  const dispatch = useDispatch();
  const applicationData = useSelector(
    (state) => state.applicationData.applicationData,
  );

  const applicationDataEdit = useSelector(
    (state) => state.applicationData.applicationDataEdit,
  );

  const applicantFee = useSelector(
    (state) => state.applicationData.applicantFee,
  );

  const dataFetchingStatus = useSelector(
    (state) => state.applicationData.dataFetchingStatus,
  );

  const errorMessage = useSelector(
    (state) => state.applicationData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.applicationData.errorStatusCode,
  );
  const preferredContactList = useSelector(
    (state) => state.applicationData.preferredContactList,
  );
  const preferredGenderCode = useSelector(
    (state) => state.applicationData.preferredGenderCode,
  );
  const applicationcertificationprogram = useSelector(
    (state) => state.applicationData.applicationcertificationprogram,
  );
  const applicationCheckList = useSelector(
    (state) => state.applicationData.applicationCheckList,
  );

  const fileList = useSelector((state) => state.applicationData.fileList);
  const [selectedDegree, setSelectedDegree] = useState("");
  const inquiry = useSelector((state) => state.applicationData.inquiry);
  const [applicationcp, setApplicationCP] = useState([]);
  const [checkList, setCheckList] = useState([]);
  if (!isObjectEmpty(applicantFee)) {
    window.localStorage.setItem(
      "eslsca_applicationfee",
      applicantFee.eslsca_applicationfee,
    );
  }
  useEffect(() => {
    if (applicationcertificationprogram.length > 0) {
      setApplicationCP(applicationcertificationprogram);
      setSelectedDegree(applicationcertificationprogram[0].ses_applicationid);
    }
  }, [applicationcertificationprogram]);
  useEffect(() => {
    if (applicationCheckList) {
      let updateApplicationCheckList = {
        ...applicationCheckList,
        ses_passport:
          applicationCheckList?.ses_passport === true ? "Yes" : "No",
        ses_resume: applicationCheckList?.ses_resume === true ? "Yes" : "No",
        ses_portfolio:
          applicationCheckList?.ses_portfolio === true ? "Yes" : "No",
        ses_interview:
          applicationCheckList?.ses_interview === true ? "Yes" : "No",
        ses_writtenessay:
          applicationCheckList?.ses_writtenessay === true ? "Yes" : "No",
        ses_transcripts:
          applicationCheckList?.ses_transcripts === true ? "Yes" : "No",
        ses_aidform: applicationCheckList?.ses_aidform === true ? "Yes" : "No",
        ses_passportnotes:
          applicationCheckList?.ses_passportnotes === null
            ? ""
            : applicationCheckList?.ses_passportnotes,
        ses_resumenotes:
          applicationCheckList?.ses_resumenotes === null
            ? ""
            : applicationCheckList?.ses_resumenotes,
        ses_portfolionotes:
          applicationCheckList?.ses_portfolionotes === null
            ? ""
            : applicationCheckList?.ses_portfolionotes,

        ses_interviewnotes:
          applicationCheckList?.ses_interviewnotes === null
            ? ""
            : applicationCheckList?.ses_interviewnotes,
        ses_writtenessaynotes:
          applicationCheckList?.ses_writtenessaynotes === null
            ? ""
            : applicationCheckList?.ses_writtenessaynotes,

        ses_transcriptnotes:
          applicationCheckList?.ses_transcriptnotes === null
            ? ""
            : applicationCheckList?.ses_transcriptnotes,
        ses_aidformnotes:
          applicationCheckList?.ses_aidformnotes === null
            ? ""
            : applicationCheckList?.ses_aidformnotes,
      };

      setCheckList(updateApplicationCheckList);
    }
  }, [applicationCheckList]);

  useEffect(() => {
    if (
      window.localStorage.getItem("x-auth-contactId") != null &&
      window.localStorage.getItem("x-auth-contactId") != ""
    ) {
      dispatch(
        getApplicationData(window.localStorage.getItem("x-auth-contactId")),
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (window.localStorage.getItem("ses_applicantid")) {
      dispatch(
        getApplicationsByAppicantId(
          window.localStorage.getItem("ses_applicantid"),
        ),
      );
    }
  }, [window.localStorage.getItem("ses_applicantid")]);

  const [jsonData, setJsonData] = useState(filtterFormData);

  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [event, setEvent] = useState({
    isEvent: false,
    message: "",
    showSnackbar: false,
  });
  const [validationError, setValidationError] = useState(false);

  const [showGuardian, setShowGuardian] = useState(false);
  const optionList = useSelector((state) => state.applicationData.optionList);
  const [fileData, setFileData] = useState({});
  const textFieldChangeHandler = (event) => {
    if (event.target.name === "firstname") {
    }
    const filtterFormDataCopy = { ...jsonData };
    filtterFormDataCopy[event.target.name] = event.target.value;
    setJsonData(filtterFormDataCopy);
    dispatch(updateApplicationEditData(filtterFormDataCopy));
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);

  useEffect(() => {
    dispatch(getInquiryData());
  }, []);

  useEffect(() => {
    if (jsonData) setJsonData(jsonData);
  }, [jsonData]);

  useEffect(() => {
    const newPersonalInformation = { ...personalInformation };
    if (inquiry.countries && inquiry.countries?.length > 0) {
      const countries = inquiry.countries.map((country) => ({
        value: country.ses_countryname,
        displayValue: country.ses_countryname,
      }));
      newPersonalInformation.address1_country.elementConfig.options = countries;
    }
    setPersonalInformation(newPersonalInformation);
  }, [inquiry]);

  useEffect(() => {
    const newJsonData = { ...personalInformation };
    setFormNavData((prev) => {
      const newArr = [...prev];
      const newobj = { ...newArr[0] };
      newobj.value =
        localizedStrings.application.personalInformation.personalInformation;
      newArr[0] = newobj;
      return newArr;
    });
    newJsonData.firstname.elementConfig.label =
      localizedStrings.application.personalInformation.firstName;
    newJsonData.lastname.elementConfig.label =
      localizedStrings.application.personalInformation.lastName;
    newJsonData.middlename.elementConfig.label =
      localizedStrings.application.personalInformation.middleName;
    newJsonData.ses_applicant.elementConfig.label =
      localizedStrings.application.personalInformation.ses_applicant;
    newJsonData.birthdate.elementConfig.label =
      localizedStrings.application.personalInformation.birthDate;
    newJsonData.gendercode.elementConfig.label =
      localizedStrings.application.personalInformation.genderCode.genderCode;
    newJsonData.address1_city.elementConfig.label =
      localizedStrings.application.conatactInformation.homeAddress.address1_city.address1_city;
    newJsonData.address1_city.errorMessage =
      localizedStrings.application.conatactInformation.homeAddress.address1_city.errorMessage;
    newJsonData.address1_country.elementConfig.label =
      localizedStrings.application.conatactInformation.homeAddress.address1_country.address1_country;
    newJsonData.address1_country.errorMessage =
      localizedStrings.application.conatactInformation.homeAddress.address1_country.errorMessage;
    newJsonData.address1_line1.elementConfig.label =
      localizedStrings.application.conatactInformation.homeAddress.address1_line1.address1_line1;
    newJsonData.address1_line1.errorMessage =
      localizedStrings.application.conatactInformation.homeAddress.address1_line1.errorMessage;
    newJsonData.address1_postalcode.elementConfig.label =
      localizedStrings.application.conatactInformation.homeAddress.address1_postalcode;

    setPersonalInformation(newJsonData);
  }, [language]);

  useEffect(() => {
    const newJsonData = { ...contactInformation };
    newJsonData.homePhone.elementConfig.label =
      localizedStrings.application.conatactInformation.homePhone;
    newJsonData.mobilePhone.elementConfig.label =
      localizedStrings.application.conatactInformation.mobilePhone;
    setContactInformation(newJsonData);
  }, [language]);

  useEffect(() => {
    const newJsonData = { ...emergenencyContact };
    newJsonData.name.elementConfig.label =
      localizedStrings.application.emergenencyContact.name;
    newJsonData.phone.elementConfig.label =
      localizedStrings.application.emergenencyContact.phone;
    newJsonData.relationship.elementConfig.label =
      localizedStrings.application.emergenencyContact.relationship;
    setEmergenencyContact(newJsonData);
  }, [language]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    window.localStorage.removeItem("eslsca_applicationfee");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearApplicationData());
    dispatch(clearApplicantStatus());
    props.history.push("/login");
  };
  useEffect(() => {
    if (window.localStorage.getItem("x-auth-contactId")) {
      dispatch(
        getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
      );
    }
  }, [dispatch]);

  useEffect(() => {
    window.localStorage.removeItem("password");
    window.localStorage.getItem("email");
    window.localStorage.getItem("token");
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let event = {
          isEvent: false,
          message: "Session Expired",
          showSnackbar: true,
        };

        setEvent(event);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let event = {
          isEvent: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setEvent(event);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handelDateChange = (event, eventName) => {
    const filtterFormDataCopy = { ...jsonData };
    if (eventName === "eslsca_accepttermsanddonditions") {
      filtterFormDataCopy[eventName] = event.target.checked;
    } else {
      filtterFormDataCopy[eventName] = dateFormatter(event);
    }

    setJsonData(filtterFormDataCopy);
    dispatch(updateApplicationEditData(filtterFormDataCopy));
  };
  const handleProgramChange = (eventName, programValue) => {
    let programName = programs.find((data) => {
      return data.value === programValue;
    });
    if (programName.displayValue.includes("Bachelor")) {
      let copyApplicationDataEdit = { ...applicationDataEdit };
      copyApplicationDataEdit[eventName] = programValue;
      copyApplicationDataEdit.ses_applicanttype = 284210001;
      setJsonData(copyApplicationDataEdit);
      dispatch(updateApplicationEditData(copyApplicationDataEdit));
      setShowGuardian(true);
    } else {
      let copyApplicationDataEdit = { ...applicationDataEdit };
      copyApplicationDataEdit[eventName] = programValue;
      copyApplicationDataEdit.ses_applicanttype = 284210000;
      setJsonData(copyApplicationDataEdit);
      dispatch(updateApplicationEditData(copyApplicationDataEdit));
      setShowGuardian(false);
    }
  };
  const handleProgramChangeOnLoad = (programValue) => {
    if (programValue !== undefined && programValue.length > 0) {
      let programName = programs.find((data) => {
        return data.value === programValue;
      });
      if (programName.displayValue.includes("Bachelor")) {
        setShowGuardian(true);
      } else {
        setShowGuardian(false);
      }
    }
  };
  const handelTransferFieldValidation = (isTransfer) => {
    if (isTransfer) {
      education.Undergraduate[
        "eslsca_transferfacultyorprogram"
      ].elementConfig.required = true;
      education.Undergraduate[
        "eslsca_semesternumberfortransfer"
      ].elementConfig.required = true;
      fields.underGraduate.eslsca_transferfacultyorprogram =
        "Current Faculty or Study Program";
      fields.underGraduate.eslsca_semesternumberfortransfer = "Semester Number";
    } else {
      delete education.Undergraduate["eslsca_transferfacultyorprogram"]
        .elementConfig.required;
      delete education.Undergraduate["eslsca_semesternumberfortransfer"]
        .elementConfig.required;

      delete fields.underGraduate.eslsca_transferfacultyorprogram;
      delete fields.underGraduate.eslsca_semesternumberfortransfer;
    }
  };

  const handelChange = (event, eventName) => {
    const filtterFormDataCopy = { ...jsonData };
    if (eventName === "_ses_certificationprogram_value") {
      handleProgramChange(eventName, event.target.value);
    } else if (
      eventName === "mobilephone" ||
      eventName === "gurd_mobilephone"
    ) {
      const countryName = countryCodes.findOne(
        "countryCode",
        event.target.value,
      );

      if (filtterFormDataCopy[eventName] === undefined) {
        filtterFormDataCopy[eventName] =
          "+" + countryName.countryCallingCode + "-";
      } else {
        filtterFormDataCopy[eventName] = filtterFormDataCopy[eventName].replace(
          filtterFormDataCopy[eventName].substr(0, 5),
          "+" + countryName.countryCallingCode + "-",
        );
      }

      setJsonData(filtterFormDataCopy);
      dispatch(updateApplicationEditData(filtterFormDataCopy));
    } else {
      if (eventName === "eslsca_transfer" && showGuardian) {
        handelTransferFieldValidation(event.target.value);
      }
      filtterFormDataCopy[eventName] = event.target.value;
      setJsonData(filtterFormDataCopy);
      dispatch(updateApplicationEditData(filtterFormDataCopy));
    }
  };

  const mapDocumentType = (type) => {
    if (docType[type]) return docType[type];
    return "";
  };

  const mapDocList = (status) => {
    var value;
    if (optionList != undefined && optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele?.value?.toLowerCase();
        }
      });
    }
    return value;
  };

  useEffect(() => {
    let entity = "ses_fileuploadtype";
    let attributename = "ses_documenttype";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  const mapfileList = (status) => {
    var value;
    // if (fileList != undefined && fileList?.length != 0) {
    //   fileList?.map((ele) => {
    //     if (ele.attributevalue === status) {
    //       value = ele?.value;
    //     }
    //   });
    // }
    return value;
  };

  const setpreferredContactList = () => {
    if (!isObjectEmpty(preferredContactList)?.length != 0) {
      const transformed = preferredContactList?.map(
        ({ value: displayValue, attributevalue: value }) => ({
          displayValue,
          value,
        }),
      );

      const newJsonData = { ...miscellanous };
      newJsonData.contactMode.elementConfig.options = transformed;
    }
  };
  const setpreferredGenderCode = () => {
    if (
      !isObjectEmpty(preferredGenderCode) &&
      preferredGenderCode?.length != 0
    ) {
      const transformed = preferredGenderCode?.map(
        ({ value: displayValue, attributevalue: value }) => ({
          displayValue,
          value,
        }),
      );

      const newJsonData = { ...personalInformation };
      newJsonData.gendercode.elementConfig.options = transformed;
    }
  };

  useEffect(() => {
    let entity = "ses_fileuploadtype";
    let attributename = "ses_filetype";
    dispatch(getfileTypesList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "contact";
    let attributename = "preferredcontactmethodcode";
    dispatch(getpreferredContactList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "contact";
    let attributename = "gendercode";
    dispatch(getpreferredGenderCode(entity, attributename));
  }, [dispatch]);

  const scanForErrorFields = () => {
    let regex = /^[a-zA-Z ]*$/;
    let emailExp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let errorFields = "";
    var count = 0;
    let loopFields = "";
    if (
      jsonData.firstname.length < 3 ||
      jsonData.lastname.length < 3 ||
      !jsonData.firstname.match(regex) ||
      !jsonData.middlename.match(regex) ||
      !jsonData.lastname.match(regex) ||
      jsonData.gendercode === "" ||
      jsonData.birthdate === "" ||
      jsonData.address1_line1 === "" ||
      jsonData.address1_city === "" ||
      jsonData.address1_country === "" ||
      jsonData.ses_emergencycontactname === "" ||
      jsonData.ses_emergencycontactphone === "" ||
      jsonData.ses_emergencycontactrelationship === ""
    ) {
      setValidationError(true);
    } else {
      setValidationError(false);
    }

    if (errorFields.length !== 0) {
      let error = {
        isError: true,
        message:
          count === 1
            ? errorFields + " Field Can't be blank"
            : errorFields + " Fields Can't be blank",
        showSnackbar: false,
      };
      setError(error);
    } else {
      let error = {
        isError: false,
        message: "",
        showSnackbar: false,
      };
      setError(error);
    }
  };

  const setfileUploadFields = () => {
    var filtterFormDataCopy = { ...fileData };
    let mapFileUpload = [...applicationDataEdit.fileUploadsDetails].map(
      (element) => {
        filtterFormDataCopy[mapDocList(element.ses_documenttype)] = "";
        return {
          ses_description: element.ses_description,
          ses_mandatory: element.ses_mandatory,
          ses_documenttype: mapDocList(element.ses_documenttype),
          ses_filetype: mapfileList(element.ses_filetype),
          ses_fileuploadlineid: element.ses_fileuploadlineid,
          uploadedFileData: fileData,
        };
      },
    );
    fileUploadForm = mapFileUpload;
    setFileData(fileUploadForm);
  };

  useEffect(() => {
    if (selectedDegree) {
      dispatch(getApplicantCheckList(selectedDegree));
    }
    setpreferredGenderCode();
  }, [selectedDegree, dispatch]);

  useEffect(() => {
    if (applicationDataEdit.fileUploadsDetails) {
      scanForErrorFields();
      setfileUploadFields();
      setpreferredContactList();
    }
    setpreferredGenderCode();
  }, [language, applicationDataEdit, preferredGenderCode]);

  const handleSave = () => {
    if (error.isError) {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = true;
      setError(errorCopy);
    } else {
      let formDataValue = new FormData();
      Object.keys(fileData).forEach((e) =>
        formDataValue.append("files", fileData[e]),
      );

      formDataValue.append(
        "folderName",
        JSON.stringify(
          `${applicationDataEdit["firstname"]} ${
            applicationDataEdit["lastname"]
          }_${window.localStorage
            .getItem("x-auth-contactId")
            .replace(/-/g, "")}/ses_applicant/${
            applicationDataEdit["ses_applicant"]
          }_${applicationDataEdit["ses_applicantid"].replace(/-/g, "")}`,
        ),
      );

      dispatch(saveFileUploadData(formDataValue));
      dispatch(
        getApplicantFee({
          ses_applicantid: applicationDataEdit.ses_applicantid,
        }),
      );
      dispatch(
        postApplicationData({
          ...applicationDataEdit,
          isGuardian: showGuardian,
          contactid: window.localStorage.getItem("x-auth-contactId"),
        }),
      );
    }
  };

  const updateProgramFields = (applicationData) => {
    if (applicationData.hasOwnProperty("programs")) {
      programs = [...applicationData.programs];
      programs = programs.map((data) => {
        return {
          value: data.ses_certificationprogramid,
          displayValue: data.ses_certificationprogramname,
        };
      });
    }

    if (applicationData.hasOwnProperty("campuses")) {
      let campuses = [...applicationData.campuses];

      campuses = campuses.map((data) => {
        return {
          value: data.ses_campusid,
          displayValue: data.ses_campusname,
        };
      });
    }

    if (applicationData.hasOwnProperty("tracks")) {
      let tracks = [...applicationData.tracks];

      tracks = tracks.map((data) => {
        return {
          value: data.ses_trackid,
          displayValue: data.ses_track,
        };
      });
      education.Undergraduate["_ses_track_value"].elementConfig.options =
        tracks;
    }

    if (applicationData.hasOwnProperty("academicyear")) {
      let academicyear = [...applicationData.academicyear];

      academicyear = academicyear.map((data) => {
        return {
          value: data.ses_academicperiodid,
          displayValue: data.ses_academicperiod,
        };
      });
    }
    handleProgramChangeOnLoad(
      applicationData["_ses_certificationprogram_value"],
    );
  };
  useEffect(() => {
    if (!isObjectEmpty(applicationData)) {
      updateProgramFields(applicationData);
      setJsonData(applicationData);
      window.localStorage.setItem(
        "ses_applicantid",
        applicationData.ses_applicantid,
      );
      dispatch(updateApplicationEditData(applicationData));
    }
  }, [applicationData, dispatch]);

  const handleClose = () => {
    if (event.showSnackbar) {
      let eventCopy = { ...event };
      eventCopy.showSnackbar = false;
      setEvent(eventCopy);
    } else {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy);
    }
  };

  const getFileUploadFormDetails = () => {
    return fileUploadForm;
  };

  function renameFile(originalFile, newName) {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  }

  const handleFile = (event) => {
    var filtterFormDataCopy = { ...fileData };
    if (event.target.value) {
      filtterFormDataCopy[event.target.name] = renameFile(
        event.target.files[0].name,
        event.target.name + "-" + event.target.files[0].name,
      );
    }

    setFileData(filtterFormDataCopy);
  };

  const removeDuplicateFromObjects = (objectArray) => {
    const filterArray = [];
    const hashMap = {};
    if (objectArray.length > 0) {
      for (let i = 0; i < objectArray.length; i += 1) {
        const currentElement = objectArray[i];
        if (!hashMap[currentElement.ses_documenttype]) {
          hashMap[currentElement.ses_documenttype] = true;
          filterArray.push(currentElement);
        }
      }
    }
    return filterArray;
  };

  return (
    <Aux>
      <MessageIndicator
        open={event.showSnackbar || error.showSnackbar}
        message={error.message || event.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid className={classes.container}>
        <Typography component="div" className={classes.profileFont}>
          {localizedStrings.application.applyToday}
        </Typography>
      </Grid>

      <Grid container item clsass={classes.formDesignMain}>
        <Grid
          direction="column"
          container
          item
          className={FormStyle.containerWith}
        >
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader name={formNavData[0].value} />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={formNavData[0].id}
                value={jsonData}
                changed={textFieldChangeHandler}
                handelChange={handelChange}
                handelDateChange={handelDateChange}
              />
            </div>
          </Typography>
        </Grid>
        <Grid
          direction="column"
          container
          item
          className={FormStyle.containerWith}
        >
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader
              name={
                localizedStrings.application.conatactInformation
                  .conatactInformation
              }
            />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={formNavData[1].id}
                value={jsonData}
                changed={textFieldChangeHandler}
                handelChange={handelChange}
                handelDateChange={handelDateChange}
              />
            </div>
          </Typography>
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader
              name={
                localizedStrings.application.emergenencyContact
                  .emergenencyContact
              }
            />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={formNavData[2].id}
                value={jsonData}
                changed={textFieldChangeHandler}
                handelChange={handelChange}
                handelDateChange={handelDateChange}
              />
            </div>
          </Typography>
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader
              name={localizedStrings.application.miscellanous.miscellanous}
            />
            <div className={classes.formDesign}>
              <FormBuilder
                formDetails={formNavData[3].id}
                value={jsonData}
                changed={textFieldChangeHandler}
                handelChange={handelChange}
                handelDateChange={handelDateChange}
              />
            </div>
          </Typography>
        </Grid>
        <Grid direction="column" container item>
          <UploadForm
            fileHandle={handleFile}
            formDetails={removeDuplicateFromObjects(getFileUploadFormDetails())}
            uploadedFile={applicationDataEdit.files}
          />
        </Grid>

        <Grid container item className={classes.bottomControls}>
          <Typography component="div" className={classes.btnNext}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                dispatch(clearErrorStatusCode());
                handleSave();
              }}
              disabled={error.isError || validationError}
            >
              {localizedStrings.students.selectClasses.submit}
            </Button>
          </Typography>
        </Grid>
        <Grid container item className={classes.tableStyle}>
          <FormHeader name="Application Details" />
          <br />
          <FormControl className={classes.formControl}>
            <InputLabel id="degree-plan">Certification Program</InputLabel>

            <Select
              labelId="certification-program"
              id="certification-program"
              value={selectedDegree}
              defaultValue={selectedDegree}
              disabled={applicationcertificationprogram.length === 0}
              onChange={(event) => setSelectedDegree(event.target.value)}
            >
              <MenuItem value="" style={{ display: "none" }}></MenuItem>
              {applicationcertificationprogram?.map((data) => (
                <MenuItem
                  key={data.ses_applicationid}
                  value={data.ses_applicationid}
                >
                  {data.ses_certificationprogramname}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <br />

          <CheckList data={checkList} />
          <br />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default withRouter(ProspectivePage);
